<template>
  <div class="marker-content">
    <h6>{{ hydrant.name }}</h6>
    <div id="bodyContent">
      <p class="font-weight-bold">
        {{ this.hydrantTypeLabel }}
        <small v-if="isTank" class="text-muted">
          ({{ hydrant.tank_capacity }} gallons)</small
        >
      </p>
    </div>

    <p v-if="isOutOfService" class="font-weight-bold text-danger">
      HYDRANT OUT OF SERVICE. DO NOT USE
    </p>
    <p v-if="isNotTested" class="font-weight-bold text-danger">
      NO TEST RECORDED. HYDRANT MAY BE OUT OF SERVICE. USE WITH CAUTION.
    </p>
    <p v-if="needsFollowUp" class="font-weight-bold text-primary">
      Hydrant needs a follow up check no earlier than {{ needsFollowUpDate }}.
      See notes.
    </p>
    <p v-if="hasStaffNotes">
      Notes from full timers:<br />{{ hydrant.staff_notes }}
    </p>
    <span v-if="hasLastCheckNote">
      <p class="font-weight-bold">
        Notes from last check<span
          class="font-weight-bold"
          v-if="hasLastTestedDate"
        >
          ({{ lastTestedDate }})</span
        >:
      </p>

      <p>{{ hydrant.last_check_note }}</p>
    </span>

    <p>
      <router-link :to="'/hydrants/' + this.hydrant.id"
        >View History</router-link
      >
    </p>

    <p>Last tested: {{ lastTestedDate }}</p>
    <p>
      <router-link
        class="btn btn-primary mt-2 btn-block"
        :to="'/hydrants/' + hydrant.id + '/hydrant_checks/new'"
      >
        record a test
      </router-link>
    </p>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    hydrant: {
      type: Object,
      required: true
    }
  },
  computed: {
    hydrantTypeLabel() {
      if (this.hydrant.hydrant_type === "dry") return "Dry Hydrant";
      else if (this.hydrant.hydrant_type === "tank") return "Underground Tank";
      else if (this.hydrant.hydrant_type === "muni") return "Municipal Hydrant";
      else return "Unknown";
    },
    lastTestedDate() {
      return this.hydrant.last_tested_at == null
        ? "Never"
        : moment(this.hydrant.last_tested_at).fromNow();
    },
    hasLastTestedDate() {
      return (
        this.hydrant.last_tested_at !== null &&
        this.hydrant.last_tested_at !== ""
      );
    },
    needsFollowUpDate() {
      return this.hydrant.needs_follow_up === null
        ? null
        : moment(this.hydrant.needs_follow_up).format("MMMM Do YYYY");
    },
    isTank() {
      return this.hydrant.hydrant_type === "tank";
    },
    isOutOfService() {
      return this.hydrant.out_of_service;
    },
    isNotTested() {
      return (
        this.$store.state.hydrantChecks.filter(check => {
          return check.hydrant_id === this.hydrant.id;
        }) === []
      );
    },
    needsFollowUp() {
      return this.hydrant.needs_follow_up !== null;
    },
    hasStaffNotes() {
      return (
        this.hydrant.staff_notes !== null && this.hydrant.staff_notes !== ""
      );
    },
    hasLastCheckNote() {
      return (
        this.hydrant.last_check_note !== null &&
        this.hydrant.last_check_note !== ""
      );
    }
  }
};
</script>
